module.exports = "/build/web/svg/icon-swipe--white.53f81143b76e9c1106deb123e4539b43.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-swipe--white.svg
// module id = 129
// module chunks = 13